$(document).ready(function(){
  /************************* Shop By Vehicle ************************/
  const getStorageGarageList = () => {
    return JSON.parse(window.localStorage.getItem('vehicleSearchParams')) || {};
  }

  const getDefaultVehicle = () => {
    let storedGarageList = getStorageGarageList();
    let garage = storedGarageList.length > 0 ? storedGarageList[0] : [];
    return {
      year: requestParams.year ? requestParams.year : (garage.year || ''),
      make: requestParams.make ? requestParams.make : (garage.make || ''),
      model: requestParams.model ? requestParams.model : (garage.model || ''),
    }
  }
  const ShopVehicleApp = createApp({
    setup() {
      let defaultVehicle = getDefaultVehicle();
      const vehicleData = reactive([
        {
          field: 'year',
          data: [],
          select: defaultVehicle.year,
          search: '',
          loading: false,
          open: false,
          searchIndex: -1
        },
        {
          field: 'make',
          data: [],
          select: defaultVehicle.make,
          search: '',
          loading: false,
          open: false,
          searchIndex: -1
        },
        {
          field: 'model',
          data: [],
          select: defaultVehicle.model,
          search: '',
          loading: false,
          open: false,
          searchIndex: -1
        },
        {
          field: 'trim',
          data: [],
          select: '',
          search: '',
          open: false,
          searchIndex: -1
        }
      ]);
      const vehicleComplete = ref(false);

      const checkVehicleState = () => {
        let complete = 1;

        vehicleData.map((item) => {
          if(item.select === '')
          {
            complete = 0;
          }
        })

        vehicleComplete.value  = complete === 1
        return vehicleComplete.value;
      }

      const setSelect = async (operateItem, operateIndex) => {
        if(vehicleData[operateIndex].select !== operateItem)
        {
          vehicleData[operateIndex].select = operateItem;

          checkVehicleState();

          vehicleData.map((item, index) => {
            if (index > operateIndex) {
              vehicleData[index].select = '';
              vehicleData[index].data = [];
            }
          })

          if(operateIndex < vehicleData.length)
          {
            await getVehicleData(operateIndex+1)
          }
        }
      }

      const containsIgnoreCase = (keyword, item, itemIndex, VehicleIndex) => {
        let matchStatus = !keyword || new RegExp(keyword, "i").test(item);

        if(matchStatus && (vehicleData[VehicleIndex].searchIndex < 0 || itemIndex < vehicleData[VehicleIndex].searchIndex))
        {
          vehicleData[VehicleIndex].searchIndex = itemIndex;
        }

        return matchStatus;
      }

      vehicleData.map((vehicle, index) => {
        watch(() => vehicleData[index].search, (newSearch, oldSearch) => {
          if(newSearch !== oldSearch)
          {
            $('.vehicle-select-box.open ul').scrollTop(0);
            vehicleData[index].searchIndex = -1;
          }
        })
      })

      const setVehicleSelect = (search, select, item, index, vehicleIndex) => {
        if(search)
        {
          return vehicleData[vehicleIndex].searchIndex === index
        }
        if(item)
        {
          return item == select;
        }

        return index === 0;
      }

      const getVehicleParams = (changeIndex) => {
        let vehicleParams = {};
        vehicleData.some((item, index) =>
        {
          if (item['select'] !== '' && (changeIndex < 0 || index < changeIndex) && item.select) {
            vehicleParams[item['field']] = item.select;
          }
          else
          {
            return true;
          }
        })
        return vehicleParams;
      }

      const getVehicleData = async (changeIndex = -2, isFirst = false) => {
        let params = {
          'collection_id': collection_id,
          'first': isFirst ? 2 : 0,
          'field': '',
        };
        params = { ...params, ...getVehicleParams(changeIndex)}

        if(!vehicleData[changeIndex])
        {
          params['field'] = 'engine';
        }
        else
        {
          vehicleData[changeIndex].loading = true;
        }

        await fetch(API_HOST + "/vehicle/info", {
          method: "post",
          cache: "no-cache",
          headers: {
            'Content-Type': 'application/json' // 设置请求头
          },
          body: JSON.stringify(params),
        })
          .then((response) => response.json())
          .then((result) => {
            if(isFirst)
            {
              let openStatus = true;
              for(let index = 0; index < vehicleData.length; index++)
              {
                let vehicleItem = vehicleData[index];
                let vehicleResult = result.result[vehicleItem.field];

                if(vehicleItem.field === 'year')
                {
                  vehicleItem.select  = Number.parseInt(vehicleItem.select);
                }

                if(vehicleResult && (vehicleItem.select === '' || vehicleResult.includes(vehicleItem.select)))
                {
                  vehicleData[index].data = vehicleResult;
                }
                else
                {
                  vehicleData[index].select = '';
                  vehicleData[index].open = openStatus;

                  if(openStatus)
                  {
                    getVehicleData(index);
                  }
                  openStatus  = false;
                }
              }
            }
            else if(result.result['engine'])
            {
              ProductListApp.engineList = result.result['engine']
            }
            else
            {
              vehicleData[changeIndex].data = result.result[vehicleData[changeIndex].field];
              vehicleData[changeIndex].loading = false;
            }
          })
          .catch((error) => {
            console.error(error);
          });
      };

      getVehicleData(0, Object.keys(getVehicleParams(-1)).length === 3);

      const getVehicleInfo = () => {
        return getVehicleParams(-1);
      }

      return {
        setVehicleSelect,
        setSelect,
        containsIgnoreCase,
        vehicleData,
        getVehicleData,
        getVehicleInfo,
        vehicleComplete,
        checkVehicleState
      };
    }
  }).mount('#shop-vehicle-box')

  const ProductListApp = createApp({
    setup() {
      const productList = ref([])
      const selectedVehicle = ref([])
      const engineList = ref([])
      const selectedEngine = ref('0')

      watch(() => selectedEngine.value, (newEngine, oldEngine) => {
        if(newEngine != oldEngine)
        {
          getProductList(ShopVehicleApp.getVehicleInfo())
        }
      })

      const setVehicle = () => {
        selectedVehicle.value = ShopVehicleApp.getVehicleInfo();
      }

      const getProductList = async () => {
        productList.value = [];

        if(selectedEngine.value == 0)
        {
          return;
        }
        await fetch(API_HOST + "/products/getSpecialList", {
          method: "post",
          cache: "no-cache",
          headers: {
            'Content-Type': 'application/json' // 设置请求头
          },
          body: JSON.stringify({
            ...selectedVehicle.value,
            collection_id:collection_id,
            engine:selectedEngine.value
          }),
        })
          .then((response) => response.json())
          .then(async (result) => {
            fetch('/cart.js')
              .then(response => response.json())
              .then(data => {
                productList.value = formatProductStocks(data, result.products)
              })
          })
          .catch((error) => {
            console.error(error);
          });
      }
      const operateQuantity = (index, type) => {
        if(!productList.value[index] || !productList.value[index].default.inventory_quantity > 0)
        {
          return;
        }

        if(type === 'minus')
        {
          productList.value[index]['default']['quantity'] =
            productList.value[index]['default']['quantity'] > 1 ?
              productList.value[index]['default']['quantity']-1 : 1
        }
        else
        {
          productList.value[index]['default']['quantity'] = productList.value[index]['default']['quantity']+1;
        }
      }
      const addToCart = async (index) => {
        if(!productList.value[index] || productList.value[index].loading)
        {
          return;
        }
        productList.value[index].loading = true;
        let params = {
          items: [
            {
              id: productList.value[index]['default']['variant_id'],
              quantity: productList.value[index]['default']['quantity'],
              properties:{...ShopVehicleApp.getVehicleInfo()}
            }
          ]
        }
        await fetch(
          '/cart/add.js',
          {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json'
            },
            body: JSON.stringify(params)
          })
          .then(response => response.json())
          .then(data => {
            if(data.items && data.items.length > 0)
            {
              productList.value[index]['add_state'] = 1;
              productList.value[index]['message'] = '';
              simpleCartApp.openCart();
            }
            else
            {
              productList.value[index]['add_state'] = 0;
              productList.value[index]['message'] = data.message;
            }
            productList.value[index].loading = false;
          })
          .catch(error => {

          });
      }

      const formatProductStocks = (cartData, productList) =>
      {
        if(cartData.items && cartData.items.length > 0)
        {
          cartData.items.forEach(item => {
            productList.forEach(product => {
              if (item.variant_id === product.default.variant_id) {
                product.default.inventory_quantity -= item.quantity;
              }
            });
          });
        }
        return productList;
      }
      return {
        selectedVehicle,
        operateQuantity,
        productList,
        getProductList,
        addToCart,
        engineList,
        selectedEngine,
        setVehicle
      };
    }
  }).mount('.special-product-template');

  $('.vehicle-select').on('click', async function(){
    if($(this).parent().hasClass('open'))
    {
      $(this).parent().removeClass('open');
      $('.vehicle-select-box.open li').removeClass('selected');
    }
    else
    {
      $('.vehicle-select-box.open').removeClass('open');
      if($(this).next('.vehicle-list').find('li').length === 0)
      {
        let dataKey = parseInt($(this).attr('data-key'));
        await ShopVehicleApp.getVehicleData(dataKey);
      }
      $(this).parent().addClass('open').queue(function(next) {
        countDefaultVehicleListScrollTop();
        $(this).parent().find('.vehicle-search-input').focus();
        next();
      });
    }
  })

  $('.vehicle-select-box').on('click', '.vehicle-list ul > li', async function(){
    $(this).parent().children().removeClass('selected');
    $(this).addClass('selected');
    let vehicleIndex = Number.parseInt($(this).parent().attr('vehicle-index'));
    let vehicleBox = $('.vehicle-select-box');
    vehicleBox.eq(vehicleIndex).removeClass('open');

    await ShopVehicleApp.setSelect($(this).html(), vehicleIndex)
    let nextObj = vehicleBox.eq(vehicleIndex+1);

    if(nextObj)
    {
      nextObj.addClass('open').queue(function(next) {
        $(this).parent().find('.vehicle-search-input').focus();
        next();
      });
    }
  })

  function moveVehicleFocus(keyCode)
  {
    let vehicleObj = $('.vehicle-select-box.open');
    if(!vehicleObj)
    {
      return ;
    }

    let selectedVehicleObj = $('.vehicle-select-box.open li.selected');

    if(keyCode === 13)
    {
      selectedVehicleObj.click();
      return ;
    }

    if(!selectedVehicleObj.length > 0)
    {
      if(keyCode === 38)
      {
        return ;
      }

      $('.vehicle-select-box.open li:first').addClass('selected');
    }
    else
    {
      let containerObj = selectedVehicleObj.parent()
      let containerScrollTop = containerObj.scrollTop()
      let containerHeight = containerObj.height();

      let vehicleHeight = selectedVehicleObj.outerHeight()

      let nextVehicleObj = keyCode === 38 ? selectedVehicleObj.prev() : selectedVehicleObj.next();
      let pervTotal = nextVehicleObj.prevAll().length;
      let positionValue = 0;

      if(keyCode === 38)
      {
        positionValue = pervTotal * vehicleHeight;
        positionValue = (positionValue - containerScrollTop) >= vehicleHeight ? containerScrollTop : positionValue;
      }
      else
      {
        positionValue = (pervTotal+1) * vehicleHeight - containerHeight;
        positionValue = (positionValue - containerScrollTop) < vehicleHeight ? containerScrollTop : positionValue;
      }

      containerObj.scrollTop(positionValue);

      if(nextVehicleObj.length > 0)
      {
        selectedVehicleObj.removeClass('selected');
        nextVehicleObj.addClass('selected');
      }
    }
  }

  const countDefaultVehicleListScrollTop = ()=>
  {
    let selectedVehicleObj = $('.vehicle-select-box.open li.selected');
    if(!selectedVehicleObj)
    {
      return ;
    }

    let containerObj = selectedVehicleObj.parent()
    let vehicleHeight = selectedVehicleObj.outerHeight()
    let pervTotal = selectedVehicleObj.prevAll().length;

    let positionValue = pervTotal * vehicleHeight;

    containerObj.scrollTop(positionValue);
  }

  $(document).keydown(function(event) {
    let keyCode = event.which || event.key;
    if (keyCode === 38 || keyCode === 40 || keyCode === 13) {
      moveVehicleFocus(keyCode);
    }
  });

  $('#selectProduct').on('click', async function(){
    let actionObj = $(this).find('.fa-spinner:first-child');
    if(actionObj.hasClass('bt-show') || !ShopVehicleApp.checkVehicleState())
    {
      return;
    }
    actionObj.addClass('bt-show');
    ProductListApp.setVehicle();
    $('.site-overlay').addClass('show');
    actionObj.removeClass('bt-show');
    $('.special-product-modal').fadeIn();
  })

  $('.special-product-template-title > .fa-close, .site-overlay').on('click', function(){
    $('.site-overlay').removeClass('show');
    $('.special-product-modal').hide();
  })

  $('body').on('click', function(event){
    if (!$(event.target).closest('.vehicle-select-box').length) {
      $('.vehicle-select-box.open').removeClass('open');
      $('.vehicle-select-box.open li').removeClass('selected');
    }
  })
})
